import { useCallback, useEffect, useRef, useState } from "react";
import { openNotification } from "../Notification";
import { conectarMensagensGlobais } from "../../services/resources/mensagemGlobalSocket";
import { mensagemGlobalService } from "../../services/resources/mensagemGlobalService";
import { DrawerNaoLidas } from "./DrawerNaoLidas";
import { ModalMensagem } from "./ModalMensagem";
import { SinoNotificacao } from "./SinoNotificacao";

export const MensagensGlobaisHost = () => {
  const [naoLidas, setNaoLidas] = useState([]);
  const [modalAberto, setModalAberto] = useState(false);
  const [drawerAberto, setDrawerAberto] = useState(false);
  const [atual, setAtual] = useState(null);
  const [confirmando, setConfirmando] = useState(false);
  const modalAbertoRef = useRef(false);

  useEffect(() => {
    modalAbertoRef.current = modalAberto;
  }, [modalAberto]);

  const buscarNaoLidas = useCallback(async () => {
    const { data } = await mensagemGlobalService.listarNaoLidas();
    return Array.isArray(data) ? data : [];
  }, []);

  const carregar = useCallback(async (abrirModalSeHouver) => {
    try {
      const lista = await buscarNaoLidas();
      setNaoLidas(lista);
      if (abrirModalSeHouver && lista.length) {
        setAtual(lista[0]);
        setModalAberto(true);
      }
      return lista;
    } catch (error) {
      openNotification(
        "error",
        <strong>Não foi possível carregar as mensagens</strong>,
        error?.response?.data?.userMessage || error?.response?.data?.detail
      );
      return [];
    }
  }, [buscarNaoLidas]);

  useEffect(() => {
    carregar(true);
  }, [carregar]);

  useEffect(() => {
    const desconectar = conectarMensagensGlobais(
      async (mensagem) => {
        if (!mensagem?.codigo) return;
        try {
          const lista = await buscarNaoLidas();
          setNaoLidas(lista);
          const recebida = lista.find(
            (item) => String(item.codigo) === String(mensagem.codigo)
          );
          if (recebida && !modalAbertoRef.current) {
            setAtual(recebida);
            setModalAberto(true);
          }
        } catch (error) {
          openNotification(
            "error",
            <strong>Não foi possível carregar as mensagens</strong>,
            error?.response?.data?.userMessage || error?.response?.data?.detail
          );
        }
      },
      () => carregar(false)
    );
    return desconectar;
  }, [buscarNaoLidas, carregar]);

  function abrirDoSino() {
    setDrawerAberto(true);
  }

  function abrirMensagem(mensagem) {
    setAtual(mensagem);
    setDrawerAberto(false);
    setModalAberto(true);
  }

  async function marcarComoLida() {
    if (!atual?.codigo) return;
    setConfirmando(true);
    try {
      await mensagemGlobalService.marcarComoLida(atual.codigo);
      const restantes = naoLidas.filter((item) => item.codigo !== atual.codigo);
      setNaoLidas(restantes);
      if (restantes.length) {
        setAtual(restantes[0]);
        setModalAberto(true);
      } else {
        setAtual(null);
        setModalAberto(false);
      }
    } catch (error) {
      openNotification(
        "error",
        <strong>Não foi possível marcar como lida</strong>,
        error?.response?.data?.userMessage || error?.response?.data?.detail
      );
    } finally {
      setConfirmando(false);
    }
  }

  return (
    <>
      <SinoNotificacao quantidade={naoLidas.length} onClick={abrirDoSino} />
      <DrawerNaoLidas
        visivel={drawerAberto}
        mensagens={naoLidas}
        onFechar={() => setDrawerAberto(false)}
        onAbrir={abrirMensagem}
      />
      <ModalMensagem
        visivel={modalAberto}
        mensagem={atual}
        confirmando={confirmando}
        onMarcarLida={marcarComoLida}
        onFechar={() => setModalAberto(false)}
      />
    </>
  );
};
